export default function FourOFour() {
  console.log("forOfor");
  return (
    <div>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <h1>Sorry, no page found</h1>
    </div>
  );
}
